import { useGraphQLQuery } from '@betterment/js-runtime';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { DateRangeOption } from '../../../../../graphql/schema';
import { EnvelopeAccountPerformanceHistoryDocument } from '../../graphql/envelopeAccountPerformanceHistory.generated';

export const useEnvelopePerformanceHistory = (dateRangeOption?: DateRangeOption) => {
  const accountId = useRequiredParam('accountId');

  const { data, loading, previousData } = useGraphQLQuery(EnvelopeAccountPerformanceHistoryDocument, {
    variables: { id: accountId, dateRangeOption },
    fetchPolicy: 'cache-and-network',
  });

  return { data, loading, previousData };
};
